// import React from 'react';

// import FicheBarLike from '@/components/Autre/FicheBarLike';
// import { RegieSwitchButton } from '@/components/Regie';

const EncaissementFactureFicheBar = () => null;
/* (
  <FicheBarLike>
    <RegieSwitchButton />
  </FicheBarLike>
);
*/
export default EncaissementFactureFicheBar;
